import axios from "axios";
import {GET_ALL_SHARES, LOADING} from "../actionTypes";
import {customerToken} from "helper";
import {adminToken} from "../../helper";
// import {adminToken} from "helper";
import { AWS_ROUTING, AWS_SERVER_APIS } from "configurations";

const {SET_TRUE, SET_FALSE} = LOADING;

export const get = () => {
    return dispatch => {
        dispatch({type: SET_TRUE});
        adminToken()
            .then(token =>
                axios.get(
                    `${AWS_SERVER_APIS}/allshares`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                )
            )
            .then(res => {
                dispatch({type: GET_ALL_SHARES, payload: res?.data?.data});
            })
            .catch(err => {
                console.log(err);
            })
            .finally(_ => dispatch({type: SET_FALSE}));
    };
};
